import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Button from "../CustomButtons/Button.jsx";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Close from "@material-ui/icons/Close";
import LoaderComponent from '../Loader';
import axios from "axios";
import Api from "../../../assets/js/utils/Api";
import CustomInput from "../CustomInput/CustomInput.jsx";
import CustomSelect from "../CustomInput/CustomSelect.jsx";

import loginVideoModalStyle from "../../../assets/jss/home/loginVideoModalStyle";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

const LoginVideoModal = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        const { loginVideoDetails, allAccountTypes, accountTypes } = this.props;

        this.state = {
            allAccountTypes: allAccountTypes,
            accountTypes: accountTypes,
            loginVideoDetails: loginVideoDetails,
            saving: false,
            response: null,
            success: false,
            cancelToken: null,
            showError: false,
            errorMessage: "",
            isValidate: false,
            validation: {
                type: "",
                title: "",
                video_url: "",
                isValid: false
            },
        };

        this.updateLoginVideo = this.updateLoginVideo.bind(this);
    }
    updateLoginVideo(){
        const isValid = this.validateForm();
        if(!isValid || this.state.loading){
            return;
        }

        const {  loginVideoDetails } = this.state;
        const source = axios.CancelToken.source();
        this.setState({
            saving: true,
            cancelToken: source,
            showError: false,
        });

        const that = this;
        Api.updateLoginVideo(loginVideoDetails, source).then(data => {
            that.setState({
                success: true,
                saving: false
            });
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                this.setState({
                    saving: false,
                    showError: true,
                    errorMessage: err.message
                });
            }
        });
    }
    handleChange(e, name){
        this.setState({
            loginVideoDetails: {
                ...this.state.loginVideoDetails,
                [name]: e.target.value
            }
        });
    }
    handleDateChange(date, name){
        try{
            if(date === 'Invalid Date'){
                return true;
            }
            
            this.setState({
                loginVideoDetails: {
                    ...this.state.loginVideoDetails,
                    [name]: date.toISOString()
                }
            });
        }catch(e){ console.log(e); } 
    }
    handleCheckbox(e, name){
        this.setState({
            loginVideoDetails: {
                ...this.state.loginVideoDetails,
                [name]: e.target.checked
            }
        });
    }
    handleAdditionalChange(e, key, name){
        let { additionalVideos }  = this.state.loginVideoDetails;
        let value = e.target.value;
        additionalVideos[key][name] = value;

        this.setState({
            loginVideoDetails: {
                ...this.state.loginVideoDetails,
                additionalVideos: additionalVideos
            }
        });
    }
    validateForm(){
        let validation = {
            title: "success",
            code: "success",
            type: "success",
            isValid: true
        };
        const { loginVideoDetails } = this.state;
        if(loginVideoDetails.type.length <= 0){
            validation.type = "error";
            validation.isValid = false;
        }
        if(loginVideoDetails.title.length <= 0){
            validation.title = "error";
            validation.isValid = false;
        }
        if(loginVideoDetails.video_url.length <= 0){
            validation.video_url = "error";
            validation.isValid = false;
        }

        let isValid = true;
        if(this.state.loginVideoDetails.additionalVideos.length > 0 ){
            this.state.loginVideoDetails.additionalVideos.map(additionalVideo => {
                if(additionalVideo.title.length <= 0){
                    isValid = false;
                }
                if(additionalVideo.video_url.length <= 0){
                    isValid = false;
                }

                return null;
            });
        }

        if(isValid === false){
            validation.isValid = false;
        }

        this.setState({
            validation: validation,
            isValidate: true
        });
        return validation.isValid;
    }
    cloneInputs(){
        this.setState({
            loginVideoDetails: {
                ...this.state.loginVideoDetails,
                additionalVideos: [
                    ...this.state.loginVideoDetails.additionalVideos,
                    {
                        title: "",
                        video_url: ""
                    }
                ]
            }
        })
    }
    removeAdditonalVideo(){
        let { additionalVideos }  = this.state.loginVideoDetails;
        additionalVideos.splice(additionalVideos.length-1, 1);

        this.setState({
            loginVideoDetails: {
                ...this.state.loginVideoDetails,
                additionalVideos: additionalVideos
            }
        });
    }
    renderForm(){
        const { saving, loginVideoDetails, validation, accountTypes, allAccountTypes, isValidate } = this.state;
        const { classes, editMode } = this.props;

        return(
            <div className={classes.uploadContainer}>
                <div className={classes.fileSendingForm}>
                    <div className={classes.formFiles+" uploader-files"}>
                        {
                            editMode ?
                                <CustomSelect
                                    success={validation.type === "success"}
                                    error={validation.type === "error"}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customSelectFormControl
                                    }}
                                    labelText="Type"
                                    selectProps={{
                                        onChange: (e) => (e),
                                        value: loginVideoDetails.type
                                    }}
                                    inputProps={{
                                        name: "type",
                                        id: "input-type",
                                        className: classes.alignLeft,
                                        disabled: true
                                    }}
                                    color="info"
                                    items={allAccountTypes}
                                    itemLabel="label"
                                    itemValue="id"
                                />
                            :
                                <CustomSelect 
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    success={validation.type === "success"}
                                    error={validation.type === "error"}
                                    labelText="Type"
                                    selectProps={{
                                        onChange: (e) => this.handleChange(e,"type"),
                                        value: loginVideoDetails.type
                                    }}
                                    inputProps={{
                                        name: "type",
                                        id: "input-type",
                                        className: classes.textLeft
                                    }}
                                    items={accountTypes}
                                    itemLabel="label"
                                    itemValue="id"
                                />
                        }
                        <CustomInput
                            success={validation.title === "success"}
                            error={validation.title === "error"}
                            id="input-title"
                            labelText="Title"
                            inputProps={{
                                onChange: (e) => this.handleChange(e,'title'),
                                value: loginVideoDetails.title,
                                name: "title",
                                type: "text",
                            }}
                            color="info"
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                        <CustomInput
                            success={validation.video_url === "success"}
                            error={validation.video_url === "error"}
                            id="input-videourl"
                            labelText="Video Url"
                            inputProps={{
                                onChange: (e) => this.handleChange(e,'video_url'),
                                value: loginVideoDetails.video_url,
                                name: "code",
                                type: "text",
                            }}
                            color="info"
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                        <div className={classes.additionalVideosList}>
                            <p className={classes.textLeft}>Additional Videos</p>
                            {
                                loginVideoDetails.additionalVideos.length > 0 ?
                                    loginVideoDetails.additionalVideos.map((additionalVideo, key) => (
                                        <div className="additional-video" key={key}>
                                            <CustomInput
                                                error={isValidate && additionalVideo.title.length <= 0}
                                                id="input-title"
                                                labelText="Title"
                                                inputProps={{
                                                    onChange: (e) => this.handleAdditionalChange(e, key, 'title'),
                                                    value: additionalVideo.title,
                                                    name: "title",
                                                    type: "text",
                                                }}
                                                color="info"
                                                formControlProps={{
                                                    fullWidth: true,
                                                }}
                                            />
                                            <CustomInput
                                                error={isValidate && additionalVideo.video_url.length <= 0}
                                                id="input-videourl"
                                                labelText="Video Url"
                                                inputProps={{
                                                    onChange: (e) => this.handleAdditionalChange(e, key, 'video_url'),
                                                    value: additionalVideo.video_url,
                                                    name: "code",
                                                    type: "text",
                                                }}
                                                color="info"
                                                formControlProps={{
                                                    fullWidth: true,
                                                }}
                                            />
                                        </div>
                                    ))
                                :
                                    <></>
                            }
                            <div className="clone-input-buttons">
                                <Button color="info" onClick={() => this.cloneInputs()}>
                                    Add Another
                                </Button>
                                {
                                    loginVideoDetails.additionalVideos.length > 0 ?
                                        <Button color="info" onClick={() => this.removeAdditonalVideo()}>
                                            Remove Additional Video
                                        </Button>
                                    :
                                        <></>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={classes.transferFooter+" "+classes.fileSendingFormFooter}>
                        <Button onClick={this.updateLoginVideo} type="button" color="info">
                            {
                                saving ?
                                    <LoaderComponent align="left" saving={true} color="white" />
                                :
                                    "Save Changes"
                            }
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
    render() {
        const { success } = this.state;
        const { classes, editMode } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.modalRoot,
                    paper: classes.modal
                }}
                open={this.props.open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="loginVideoDetails-slide-title"
                aria-describedby="loginVideoDetails-slide-description"
            >
                <DialogTitle
                    id="loginVideoDetails-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    >
                    <Button
                        simple
                        className={classes.modalCloseButton+" "+classes.modalCloseButtonCustom}
                        key="close"
                        aria-label="Close"
                        onClick={() => this.props.onClose()}
                    >
                        {" "}
                        <Close className={classes.modalClose} />
                    </Button>
                    <h5 className={classes.modalTitle}>
                        {
                            editMode ?
                                "Edit Login Video"
                            :
                            "Add Login Video"
                        }
                    </h5>
                </DialogTitle>
                <DialogContent
                    id="loginVideoDetails-slide-description"
                    className={classes.modalBody}
                    >
                        {
                            success ?
                                <>
                                    <p className={classes.successMessage}>Changes saved successfully.</p>
                                    <Button
                                        color="info"
                                        onClick={() => this.props.onClose()}
                                    >
                                        Close
                                    </Button>
                                </>
                            :
                            this.renderForm()
                        }
                </DialogContent>      
            </Dialog>
        );
    }
};

LoginVideoModal.defaultProps = {
    open: false,
    editMode: false,
};
LoginVideoModal.propTypes = {
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
    open: PropTypes.bool,
    loginVideoDetails: PropTypes.object.isRequired,
    editMode: PropTypes.bool
};
export default withStyles(loginVideoModalStyle)(LoginVideoModal);
